import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContentService } from '@blk/cwp-ng-framework';
import { GlobalAnalyticsMapperUtil, TealiumAnalyticsService, TealiumConstants } from '@ddt-web/analytics';
import { ComponentRequest } from '@ddt-web/data-service';
import { SharedApplicationConstants } from '@ddt-web/domain';
import { StoreService } from '@ddt-web/store-service';
import { UrlService } from '@ddt-web/url';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as get from 'lodash/get';
import * as isEmpty from 'lodash/isEmpty';
import { of } from 'rxjs';
import { first } from 'rxjs/operators';

import { ModelsBrowseStoreConfig } from '../config/store.config';
import { ModelsBrowseDataService } from '../services/models-browse-data.service';

@UntilDestroy()
@Component({
	selector: 'mb-fund-performance',
	templateUrl: './fund-performance-fees.component.html',
	styleUrls: ['./fund-performance-fees.component.scss']
})
export class FundPerformanceFeesComponent implements OnInit {
	public componentRequests: ComponentRequest[] = [];
	public familyName: string;
	public familyId: string;
	public groupId: string;
	public modelExternalName: string;

	constructor(
		private storeService: StoreService,
		private urlService: UrlService,
		private router: Router,
		private modelsBrowseDataService: ModelsBrowseDataService,
		private contentService: ContentService,
		private tealiumAnalyticsService: TealiumAnalyticsService
	) { }

	public ngOnInit(): void {
		this.setupData();
		this.sendTrackingEvent();
	}

	private setupData(): void {
		this.familyId = this.urlService.getModelFamilyId();
		this.groupId = this.urlService.getModelGroupId();
		if (!this.familyId) {
			this.router.navigate(['/']);
			return;
		}

		// track family id using the portfolioIds
		GlobalAnalyticsMapperUtil.setPortfolioIds(this.familyId);

		this.storeService.fetch(ModelsBrowseStoreConfig.positionDetails); // to trigger loading skeleton

		this.storeService.selectById(ModelsBrowseStoreConfig.families, this.familyId)
			.pipe(first(families => !isEmpty(families)))
			.subscribe(families => {
				const defaultText = this.contentService.get('FUND_PERFORMANCE', 'FUND PERFORMANCE');
				this.familyName = get(families, [this.familyId, 'description'], defaultText);
				this.modelExternalName = this.groupId !== SharedApplicationConstants.MODEL_FAMILY.BLACKROCK_FAMILY_GROUP ? get(families, [this.familyId, 'modelExternalName'], '') : null;
			});

		this.modelsBrowseDataService.fetchFamilyPortfolioAnalysis()
			.pipe(untilDestroyed(this))
			.subscribe(familyId => {
				const familyIds$ = of([familyId]);
				this.componentRequests = [
					{ componentId: 'me.performance.fund', ids: familyIds$ },
					{ componentId: 'me.performance.fees', ids: familyIds$ }
				];
			});
	}

	public sendTrackingEvent(): void {
		GlobalAnalyticsMapperUtil.setSiteSubSubSection(TealiumConstants.MODELS_EXPERIENCE_SUB_SUB_SECTION_NAMES.FUND_PERFORMANCE);
		this.tealiumAnalyticsService.triggerPageView({ 'tool_name': TealiumConstants.MODELS_EXPERIENCE_EVENTS.MODELS_EXPERIENCE_APP_NAME });
	}
}
